// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2-ULW","col":"CardReaderDesc_col__23dCP","label":"CardReaderDesc_label__1Pqe4"};